import { makeVar } from '@apollo/client'
import type { ConsentCategory, ConsentChoice } from './types'
import { readConsentCookie } from './utils/consent-cookie'

/**
 * Current cookie choice; `null` until the visitor decides (or after a policy
 * version bump). Seeded from the cookie at module load so synchronous gates
 * such as `pushGtmEvent` see it before any effect runs.
 */
export const consentVar = makeVar<ConsentChoice | null>(readConsentCookie())

export const isConsentDialogOpenVar = makeVar(false)

export const hasConsent = (category: ConsentCategory) =>
  consentVar()?.[category] === true
